import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

export default function ThemeProvider(props) {
  return <MuiThemeProvider {...props} />;
}
